
import { PopupOptions } from 'azure-maps-control';

const popupPxOffset = [0, -40]; // NOSONAR

export const popupDefaultOptions: PopupOptions = {
  closeButton: false,
  draggable: false,
  pixelOffset: popupPxOffset,
  showPointer: true
};
